import { Router } from '@angular/router';
import { environment } from '~env/environment';
import { PageNameTypes } from '~shared/modules/application-event/constants';

export namespace UrlUtil {
  export function removeQueryParameters(parameters: string[], router: Router, onEnd?: () => void): any {
    const path = `${location.pathname}${location.search}`.replace(environment.baseHref(), '');
    let url = router.parseUrl(path).toString();
    const paramsExists = parameters.reduce((acc, param) => acc || url.includes(param), 0);
    if (paramsExists) {
      parameters.forEach((param) => {
        url = url.replace(new RegExp(`&?${param}=[^&\\$]*`), '').replace(new RegExp(`\\?&`), '?');
      });
      const finalUrl = url.replace(new RegExp('\\?$'), '');
      router.navigateByUrl(finalUrl).finally(onEnd);
    }
  }

  export const getAbsoluteUrl = (): string => {
    return window.location.href;
  };

  export const getAbsoluteUrlWithPath = (path?: string, queryParams?: object): string => {
    if (!path) {
      return environment.appBaseUrl();
    }
    const pathname = path.startsWith('/') ? path : `/${path}`;
    const url = new URL(`${environment.appBaseUrl()}${pathname}`);

    if (queryParams && Object.keys(queryParams).length) {
      Object.entries(queryParams).forEach(([key, value]) => {
        url.searchParams.set(key, value);
      });
    }

    return url.toString();
  };

  export let getQueryParam = (key: string) => {
    const searchParams: URLSearchParams = window?.location?.href && new URL(window.location.href).searchParams;
    return searchParams && searchParams.get(key);
  };

  export const generateRedirectionUrl = (backUrl?: string) => {
    const baseURL = environment.appBaseUrl().replace(new RegExp('/$'), '');

    if (backUrl) {
      const decodedBackUrl = decodeURIComponent(backUrl);
      const correctBackUrl = decodedBackUrl.startsWith('/') ? decodedBackUrl : `/${decodedBackUrl}`;
      return `${baseURL}${correctBackUrl}`;
    }

    return baseURL;
  };

  export const redirectToReactHomePage = (queryParams?: Record<string, string>): void => {
    let url = environment.appBaseUrl();
    if (queryParams) {
      const queryParamsString = new URLSearchParams(queryParams).toString();
      url = `${url}?${queryParamsString}`;
    }

    window.location.href = url;
  };

  export const redirectToExternalPage = (backUrl: string, queryParams?: Record<string, string>): void => {
    let url = environment.appBaseUrl() + backUrl;
    if (queryParams) {
      const queryParamsString = new URLSearchParams(queryParams).toString();
      url = `${url}?${queryParamsString}`;
    }

    window.location.href = url;
  };

  export const encodeQueryParams = (rawParams: Record<string, string | number>) =>
    Object.entries(rawParams).reduce((acc, [key, value]) => {
      acc[encodeURIComponent(key)] = encodeURIComponent(value);
      return acc;
    }, {});

  export const getPageTypeFromCurrentUrl = (url: string, categoryUrlFF?: boolean): string => {
    let urlStart: string = '';
    let pageType: string = '';

    if (typeof url === 'string') {
      urlStart = url.split('/')[1];

      if (typeof urlStart === 'string') {
        pageType = urlStart.split('?')[0];
      }
    }

    let result: string;

    switch (pageType) {
      case 'b':
        result = PageNameTypes.BrandPlp;
        break;
      //CATEGORY_URL_IDENTIFIER (FF) is set true to test if anything breaks when 'category' case is removed.
      case 'category':
        if (!categoryUrlFF) {
          result = PageNameTypes.Category;
        } else {
          result = PageNameTypes.SearchResults;
        }
        break;
      case 'c':
        result = PageNameTypes.Category;
        break;
      case 'content':
        result = PageNameTypes.LandingPage;
        break;
      case 'hub':
        result = PageNameTypes.HubPage;
        break;
      case 'landing':
        result = PageNameTypes.CustomPLP;
        break;
      case 'product':
        result = PageNameTypes.ProductPage;
        break;
      default:
        result = PageNameTypes.SearchResults;
        break;
    }

    return result;
  };
}
